/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateResourceRequest,
  FieldType,
  GetResourceFieldTypesParams,
  GetResourceParams,
  GetResourcePermissionParams,
  PermissionType,
  ResourceDto,
  ResourceDtoPagination,
  ResourcePageRequest,
  UpdateResourceRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetResourceFieldTypesUrl = (params: GetResourceFieldTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Resource/GetResourceFieldTypes?${stringifiedParams}` : `/api/Resource/GetResourceFieldTypes`
}

export const getResourceFieldTypes = async (params: GetResourceFieldTypesParams, options?: Parameters<typeof customInstance>[1]): Promise<FieldType[]> => {

  return customInstance<FieldType[]>(getGetResourceFieldTypesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceFieldTypesQueryKey = (params?: GetResourceFieldTypesParams,) => {
    return [
    `/api/Resource/GetResourceFieldTypes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceFieldTypesQueryOptions = <TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(params: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceFieldTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceFieldTypes>>> = ({ signal }) => getResourceFieldTypes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceFieldTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceFieldTypes>>>
export type GetResourceFieldTypesQueryError = ErrorType<unknown>


export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceFieldTypes>>,
          TError,
          Awaited<ReturnType<typeof getResourceFieldTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceFieldTypes>>,
          TError,
          Awaited<ReturnType<typeof getResourceFieldTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceFieldTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceFieldTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(params: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceFieldTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceFieldTypes>>> = ({ signal }) => getResourceFieldTypes(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceFieldTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceFieldTypes>>>
export type GetResourceFieldTypesSuspenseQueryError = ErrorType<unknown>


export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceFieldTypesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedResourcesUrl = () => {




  return `/api/Resource/GetPaginatedResources`
}

export const getPaginatedResources = async (resourcePageRequest: ResourcePageRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceDtoPagination>(getGetPaginatedResourcesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resourcePageRequest)
  }
);}





export const getGetPaginatedResourcesMutationKey = () => ['getPaginatedResources'] as const;

export const getGetPaginatedResourcesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResources>>, TError,GetPaginatedResourcesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResources>>, TError,GetPaginatedResourcesMutationVariables, TContext> => {

const mutationKey = getGetPaginatedResourcesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedResources>>, GetPaginatedResourcesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedResources(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedResources>>>
    export type GetPaginatedResourcesMutationBody = BodyType<ResourcePageRequest>
    export type GetPaginatedResourcesMutationError = ErrorType<unknown>
    export type GetPaginatedResourcesMutationVariables = {data: BodyType<ResourcePageRequest>}

    export const useGetPaginatedResources = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResources>>, TError,GetPaginatedResourcesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedResources>>,
        TError,
        GetPaginatedResourcesMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedResourcesMutationOptions(options), queryClient);
    }
    export const getGetResourceUrl = (params: GetResourceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Resource/GetResource?${stringifiedParams}` : `/api/Resource/GetResource`
}

export const getResource = async (params: GetResourceParams, options?: Parameters<typeof customInstance>[1]): Promise<ResourceDto> => {

  return customInstance<ResourceDto>(getGetResourceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceQueryKey = (params?: GetResourceParams,) => {
    return [
    `/api/Resource/GetResource`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceQueryOptions = <TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(params: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResource>>> = ({ signal }) => getResource(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceQueryResult = NonNullable<Awaited<ReturnType<typeof getResource>>>
export type GetResourceQueryError = ErrorType<unknown>


export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(params: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResource>>> = ({ signal }) => getResource(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResource>>>
export type GetResourceSuspenseQueryError = ErrorType<unknown>


export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateResourceUrl = () => {




  return `/api/Resource/CreateResource`
}

export const createResource = async (createResourceRequest: CreateResourceRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceDto>(getCreateResourceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createResourceRequest)
  }
);}





export const getCreateResourceMutationKey = () => ['createResource'] as const;

export const getCreateResourceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResource>>, TError,CreateResourceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createResource>>, TError,CreateResourceMutationVariables, TContext> => {

const mutationKey = getCreateResourceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResource>>, CreateResourceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResource(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceMutationResult = NonNullable<Awaited<ReturnType<typeof createResource>>>
    export type CreateResourceMutationBody = BodyType<CreateResourceRequest>
    export type CreateResourceMutationError = ErrorType<unknown>
    export type CreateResourceMutationVariables = {data: BodyType<CreateResourceRequest>}

    export const useCreateResource = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResource>>, TError,CreateResourceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResource>>,
        TError,
        CreateResourceMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResourceMutationOptions(options), queryClient);
    }
    export const getUpdateResourceUrl = () => {




  return `/api/Resource/UpdateResource`
}

export const updateResource = async (updateResourceRequest: UpdateResourceRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceDto>(getUpdateResourceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateResourceRequest)
  }
);}





export const getUpdateResourceMutationKey = () => ['updateResource'] as const;

export const getUpdateResourceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResource>>, TError,UpdateResourceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResource>>, TError,UpdateResourceMutationVariables, TContext> => {

const mutationKey = getUpdateResourceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResource>>, UpdateResourceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateResource(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateResource>>>
    export type UpdateResourceMutationBody = BodyType<UpdateResourceRequest>
    export type UpdateResourceMutationError = ErrorType<unknown>
    export type UpdateResourceMutationVariables = {data: BodyType<UpdateResourceRequest>}

    export const useUpdateResource = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResource>>, TError,UpdateResourceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateResource>>,
        TError,
        UpdateResourceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResourceMutationOptions(options), queryClient);
    }
    export const getGetResourcePermissionUrl = (params: GetResourcePermissionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Resource/GetResourcePermission?${stringifiedParams}` : `/api/Resource/GetResourcePermission`
}

export const getResourcePermission = async (params: GetResourcePermissionParams, options?: Parameters<typeof customInstance>[1]): Promise<PermissionType> => {

  return customInstance<PermissionType>(getGetResourcePermissionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourcePermissionQueryKey = (params?: GetResourcePermissionParams,) => {
    return [
    `/api/Resource/GetResourcePermission`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourcePermissionQueryOptions = <TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(params: GetResourcePermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcePermissionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcePermission>>> = ({ signal }) => getResourcePermission(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourcePermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcePermission>>>
export type GetResourcePermissionQueryError = ErrorType<unknown>


export function useGetResourcePermission<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourcePermission>>,
          TError,
          Awaited<ReturnType<typeof getResourcePermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourcePermission<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourcePermission>>,
          TError,
          Awaited<ReturnType<typeof getResourcePermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourcePermission<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourcePermission<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourcePermissionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourcePermissionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(params: GetResourcePermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcePermissionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcePermission>>> = ({ signal }) => getResourcePermission(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourcePermissionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcePermission>>>
export type GetResourcePermissionSuspenseQueryError = ErrorType<unknown>


export function useGetResourcePermissionSuspense<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourcePermissionSuspense<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourcePermissionSuspense<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourcePermissionSuspense<TData = Awaited<ReturnType<typeof getResourcePermission>>, TError = ErrorType<unknown>>(
 params: GetResourcePermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourcePermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourcePermissionSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






